import * as Accounts from './Accounts';
import { default as Layout } from './AdminManagementLayout';
import * as Configurations from './Configurations';
import * as Operations from './Operations';
import * as Permissions from './Permissions';
import * as Policies from './Policies';
import * as Roles from './Roles';
import * as Users from './Users';

export default {
  Policies,
  Roles,
  Users,
  Operations,
  Layout,
  Permissions,
  Accounts,
  Configurations,
};
